import { useState } from 'react';
import { useTranscriptEditorState } from './useTranscriptEditorState';

/** Вид расшифровки: обычный, режим редактирования или выход из режима, ждущий подтверждения */
type TranscriptEditModeStep = 'view' | 'edit' | 'exitConfirm';

/**
 * Режим редактирования расшифровки у секции: вход, выход и подтверждение выхода, когда в открытой
 * форме есть несохранённая правка.
 */
export const useTranscriptEditMode = () => {
  const editor = useTranscriptEditorState();
  const [step, setStep] = useState<TranscriptEditModeStep>('view');

  const exitEditMode = () => {
    editor.closeForm();
    setStep('view');
  };

  const toggleEditMode = () => {
    if (step === 'view') {
      setStep('edit');
      return;
    }
    if (editor.isDirty) {
      setStep('exitConfirm');
      return;
    }
    exitEditMode();
  };

  return {
    editor,
    isEditMode: step !== 'view',
    isExitConfirmOpen: step === 'exitConfirm',
    toggleEditMode,
    confirmExit: exitEditMode,
    cancelExit: () => setStep('edit'),
  };
};
